import moment from 'moment';

import ApiClient from '@lib/apiClient';

import { downloadBlobFIle, printApiError } from '@utils/Util';

import { BASE_URL } from '@/constants/constant';

export const addNewMeasurementSize = async (postData) => {
	try {
		const { data } = await ApiClient.POST('measurementSize', postData);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const updateMeasurementSizeById = async (postData, id) => {
	try {
		const { data } = await ApiClient.PUT('measurementSize', postData, `/${id}`);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const fetchAllSizeCategory = async (params) => {
	try {
		const { data } = await ApiClient.GET('allSizeCategory', params);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const fetchSizeCategoryById = async (id) => {
	try {
		const { data } = await ApiClient.GET('measurementSize', `/${id}`);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const removeSizeCategoryById = async (categoryId, sizeId) => {
	try {
		const { data } = await ApiClient.DELETE(
			`${BASE_URL}/product-measurement/size/category/${categoryId}/product-size/`,
			'',
			sizeId,
			true
		);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const saveMeasurementTable = async (postData) => {
	try {
		const { data } = await ApiClient.POST('saveProductMeasurement', postData);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const addSizeForProduct = async (postData) => {
	try {
		const { data } = await ApiClient.POST('addSizeToProduct', postData);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const removeSizeFromProduct = async (postData) => {
	try {
		const { data } = await ApiClient.POST('removeSizeFromProduct', postData);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const getFittingResponse = async (productId) => {
	try {
		const { data } = await ApiClient.GET(`${BASE_URL}/assets/product-block/${productId}`, '', true);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const ApproveOrRejectMeasurementTable = async (fitId, status, productId) => {
	try {
		const { data } = await ApiClient.POST(
			`${BASE_URL}/product-measurement/measurement-type-info/${fitId}/review?status=${status}&productId=${productId}`,
			'',
			'',
			true
		);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const copyMeasurementType = async (copyFromMeasurementType, copyToMeasurementType, productId) => {
	try {
		const { data } = await ApiClient.POST(
			'copyMeasurementType',
			'',
			`?copyFromMeasurementType=${copyFromMeasurementType}&copyToMeasurementType=${copyToMeasurementType}&productId=${productId}`
		);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const fetchLatestMeasurementTypeInfo = async (productId, params = '') => {
	try {
		const { data } = await ApiClient.GET(
			`${BASE_URL}/product-measurement/measurement-type-info/product/${productId}${params}`,
			'',
			true
		);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const fetchLatestMeasurementType = async (productId) => {
	try {
		const { data } = await ApiClient.GET('latestMeasurementTypes', `${productId}`);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const copyMeasurementToAnotherProduct = async (
	measurementTypeId,
	productId,
	measurementType,
	sizeId = null
) => {
	try {
		let params = `?id=${measurementTypeId}&productId=${productId}&measurementType=${measurementType}`;
		if (sizeId) {
			params += `&productSizeId=${sizeId}`;
		}
		const { data } = await ApiClient.POST('copyMeasurementToAnotherProduct', '', params);
		return data;
	} catch (error) {
		printApiError(error, 12000);
	}
};

export const downloadMeasurementInPDF = async (id, unitType, measurementType = '') => {
	try {
		let currentTime = moment(new Date()).format('DD MMM [AT] hh:mm A');
		let params = `${id}?currentTime=${currentTime}&unit=${unitType}&measurementType=${measurementType}`;
		const { data } = await ApiClient.POST('measuremrntPdfDownload', {}, params);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const downloadMeasurementInExcel = async (productId, unitType, measurementType = '') => {
	try {
		const response = await ApiClient.GET_FILE_DATA(
			`${BASE_URL}/product-measurement/${productId}/download/excel?unit=${unitType}&measurementType=${measurementType}`,
			'',
			true
		);
		downloadBlobFIle(response);
	} catch (error) {
		printApiError(error);
	}
};

export const blockInfoAddUpdate = async (postData) => {
	try {
		const { data } = await ApiClient.POST('blockInfoAddUpdate', postData);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const fetchMeasurementHistoryList = async (productId, measurementType) => {
	try {
		const { data } = await ApiClient.GET(
			`${BASE_URL}/product-measurement/history/all/${productId}/${measurementType}`,
			'',
			true
		);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const fetchMeasurementHistoryByHistoryId = async (historyId) => {
	try {
		const { data } = await ApiClient.GET(
			`${BASE_URL}/product-measurement/history/${historyId}`,
			'',
			true
		);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const increaseSizeCategorySequence = async (productId, sizeCategoryId, measurementType) => {
	try {
		const { data } = await ApiClient.POST(
			'increaseSizeCategorySequence',
			'',
			`?productId=${productId}&sizeCategoryId=${sizeCategoryId}&measurementType=${measurementType}`
		);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const removeSizeCategorySequence = async (productId, sizeCategoryId, measurementType) => {
	try {
		const { data } = await ApiClient.POST(
			'removeSizeCategorySequence',
			'',
			`?productId=${productId}&sizeCategoryId=${sizeCategoryId}&measurementType=${measurementType}`
		);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const setCurrentMeasurementType = async (productId, measurementType) => {
	try {
		const { data } = await ApiClient.POST(
			'setCurrentMeasurementType',
			'',
			`?productId=${productId}&measurementType=${measurementType}`
		);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const setMeasurementShowColumn = async (param) => {
	try {
		const { data } = await ApiClient.POST('setMeasurementShowColumn', '', param);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const initMeasurementTable = async (productId, measurementType, unit) => {
	try {
		const { data } = await ApiClient.POST(
			'initMeasurementTable',
			'',
			`?productId=${productId}&measurementType=${measurementType}&unit=${unit}`
		);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const getPairFabricById = async (fabricId) => {
	try {
		const { data } = await ApiClient.GET(
			`${BASE_URL}/material/fabric/fabric-with-supplier/${fabricId}`,
			'',
			true
		);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const fetchAllCategoryWiseSubCategoryCount = async () => {
	try {
		const { data } = await ApiClient.GET('getCategoryWiseSubCategoryCount');
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const showAllHiddenSizeColumn = async (param) => {
	try {
		const { data } = await ApiClient.POST('showAllHiddenSizeColumn', '', param);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const fetchAllCategoryWiseSubCategoryList = async (id) => {
	try {
		const { data } = await ApiClient.GET('categoryAction', `${id}/subcategories-with-doc`);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const fetchSubCategory = async (id) => {
	try {
		const { data } = await ApiClient.GET('categoryAction', `subcategory/${id}`);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const addSubcategory = async (body, id) => {
	try {
		const { data } = await ApiClient.POST('categoryAction', body, `${id}/subcategory`);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const updateSubcategory = async (body, id) => {
	try {
		const { data } = await ApiClient.PUT('categoryAction', body, `subcategory/${id}`);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const addCategoryWiseMarketAndFabricType = async (body, id) => {
	try {
		const { data } = await ApiClient.POST(
			'categoryAction',
			body,
			`${id}/category-wise-market-and-fabric-type`
		);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const duplicateMeasurement = async (pomId) => {
	try {
		const { data } = await ApiClient.POST('duplicateMeasurement', {}, `${pomId}`);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

// Measurement Block suggestions
export const fetchProductBlocks = async (params) => {
	try {
		const { data } = await ApiClient.GET('fetchProductBlocks', params);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const loadPomTemplate = async (body, id) => {
	try {
		const { data } = await ApiClient.POST('loadPomTemplate', body, `/${id}`);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const createRangePlanCategory = async (categoryId, subCategoryId) => {
	try {
		const { data } = await ApiClient.GET(
			'categoryAction',
			`${categoryId}/create-range-planing-category/${subCategoryId}`
		);
		return data;
	} catch (error) {
		printApiError(error);
	}
};
